













































































































































































































































import { Component, Prop, Vue, Mixins } from 'vue-property-decorator'
import UserApi from '@/api/user'
import SystemApi from '@/api/system'
import TaskApi from '@/api/task'
import cloneDeep from 'lodash/cloneDeep'
import PageLayout from '@/components/page/PageLayout.vue'
import listMixins from '@/mixins/list'
import { userName } from '@/utils/regExp'
import { nameLength } from '@/config/global'
import LabelList from '@/components/Label/LabelList.vue'

@Component({
	name: 'DispatchList',
	components: {
		PageLayout,
		LabelList,
	},
})
export default class UsersList extends Mixins(listMixins) {
	private visible: boolean = false

	private addForm: any = {}
	private modForm: any = {}

	private companyOptions: any = []

	private userName: any = userName
	private nameLength: any = nameLength

	// 表头
	private columns: any = [
		{
			title: '序号',
			dataIndex: 'order',
			align: 'center',
			width: 60,
			scopedSlots: { customRender: 'order' },
		},
		{
			title: '规则ID',
			align: 'center',
			dataIndex: 'ruleNo',
		},
		{
			title: '规则名称',
			align: 'center',
			dataIndex: 'ruleName',
		},
		{
			title: '规则状态',
			align: 'center',
			dataIndex: 'ruleStatus',
			scopedSlots: { customRender: 'ruleStatus' },
		},
		{
			title: '规则等级',
			align: 'center',
			dataIndex: 'ruleLevel',
		},
		{
			title: '规则适用保司',
			align: 'center',
			dataIndex: 'insurance',
			scopedSlots: { customRender: 'insurance' },
		},
		{
			title: '规则适用区域',
			align: 'center',
			dataIndex: 'areaDesc',
			scopedSlots: { customRender: 'area' },
		},
		{
			title: '生效资源公司',
			align: 'center',
			dataIndex: 'partner',
			scopedSlots: { customRender: 'partner' },
		},
		{
			title: '生效时间',
			align: 'center',
			dataIndex: 'effectStartTime',
			scopedSlots: { customRender: 'effectStartTime' },
		},
		{
			title: '设置人员',
			align: 'center',
			dataIndex: 'updatorName',
		},
	]

	private rolesOptions: any[] = []
	private data: any[] = []
	private first: boolean = true
	private searchRoles: any = []
	private title: any = '新增用户'

	private addLoading: boolean = false
	private modLoading: boolean = false

	private getInsurances(list: any) {
		return list.map((item: any, index: number) => {
			return `${index + 1}.${item.companyName}`
		})
	}

	private getPartners(list: any) {
		return list.map((item: any, index: number) => {
			return `${index + 1}.${item.companyName}`
		})
	}

	private getAreas(areaDesc: any) {
		return areaDesc
			.replace(/(\d+)/g, '=$1')
			.split('=')
			.filter((item: any) => !!item)
	}

	public async created() {
		this.addForm = this.$form.createForm(this)
		this.modForm = this.$form.createForm(this)
	}

	public activated() {
		this.$store.dispatch('setting/initCompanyTree').then((res: any) => {
			this.setCompanyAsTree()
		})
		this.$store.dispatch('setting/initAreas')
		this.$store.dispatch('setting/initPartnerTree')
		this.getList()
		// this.getRoles()
	}

	private get isUpdate() {
		return !!this.selected[0]
	}

	private get ruleLevelList() {
		const arr = []
		for (let i = 1; i <= 9; i++) {
			arr.push({
				key: i,
				value: i,
			})
		}
		return arr
	}

	private getForm() {
		const form: any = this.getSearchValues()
		// form.beginTime =
		// 	form.rangeTime &&
		// 	form.rangeTime[0] &&
		// 	form.rangeTime[0].format('YYYY-MM-DD')
		// form.endTime =
		// 	form.rangeTime &&
		// 	form.rangeTime[1] &&
		// 	form.rangeTime[1].format('YYYY-MM-DD')
		// delete form.rangeTime
		if (form.insurance && form.insurance.value) {
			const insurance = String(form.insurance.value).trim()
			if (insurance) {
				form.insurance = insurance
			} else {
				delete form.insurance
			}
		}
		if (form.area) {
			const area = form.area
			const obj: any = {}
			if (area.slice(-2) !== '00') {
				obj.countryCode = area
			}
			if (area.slice(2, 4) !== '00') {
				obj.cityCode = `${area.slice(0, 4)}00`
			}
			obj.provinceCode = `${area.slice(0, 2)}0000`
			form.area = obj
		}

		return form
	}

	public getList() {
		return SystemApi.getList(this.getForm()).then((data: any) => {
			this.data = data.data.retList
			this.total = data.data.count
			this.resetSelected()
		})
	}

	private doAdd() {
		this.addForm.validateFields((err: any, values: any) => {
			if (!err) {
				this.addLoading = true
				values = cloneDeep(values)
				values.roleCodes = [values.roleCodes]
				values.companyId = values.companyId.value
				const selected = this.selected[0]
				let p: any = ''
				if (selected) {
					values.employeeId = selected.employeeId
					p = UserApi.updateUser(values).then((res: any) => {
						this.$message.success('更新成功')
						this.visible = false
						this.getList()
					})
				} else {
					p = UserApi.addUser(values).then((res: any) => {
						if (res.data) {
							this.$success({
								title: '提示',
								content: res.data,
								okText: '确定',
							})
						} else {
							this.$message.success('添加用户成功')
						}
						this.visible = false
						this.resetPage()
						this.getList()
					})
				}
				p.finally(() => {
					this.addLoading = false
				})
			}
		})
	}

	private get areas() {
		const areas = cloneDeep(this.$store.state.setting.areas)
		for (const item of areas) {
			item.isLeaf = true
		}
		return [
			{
				isLeaf: true,
				key: '000000',
				title: '全国',
				value: '000000',
			},
		].concat(areas)
	}

	private modifyRule() {
		if (this.checkSelected()) {
			this.$ss.set('updateRule', this.selected[0])
			this.$router.push('/Settings/DispatchUpdate')
		}
	}

	private getRoles() {
		UserApi.getRoles({
			filterbyType: 0,
		}).then((res: any) => {
			this.searchRoles = res.data.map((item: any) => {
				return {
					key: item.code,
					value: item.name,
				}
			})
		})
	}

	private onCompanyChange(val: any) {
		this.rolesOptions = []
		this.addForm.setFieldsValue({
			roleCodes: undefined,
		})
		if (!val) {
			return
		}
		UserApi.getRoles({
			companyId: val.value,
			filterbyType: 1,
		}).then((res: any) => {
			this.rolesOptions = res.data
		})
	}

	private resetPwd() {
		if (this.checkSelected()) {
			const selected = this.selected[0]
			this.$confirm({
				title: '提示',
				content: `确认将该用户密码重置为${this.$store.state.setting.INITPWD}吗 ?`,
				onOk: () => {
					return UserApi.resetPwd(selected.username).then((res: any) => {
						this.$message.success('重置成功')
						this.getList()
					})
				},
			})
		}
	}

	private enable() {
		if (this.checkSelected()) {
			const selected = this.selected[0]
			this.$confirm({
				title: '提示',
				content: '确认启用吗 ?',
				onOk: () => {
					const form = {
						id: selected.id,
						ruleStatus: 1,
					}
					return SystemApi.enable(form).then((res: any) => {
						this.$message.success('启用成功')
						this.getList()
					})
				},
			})
		}
	}

	private disable() {
		if (this.checkSelected()) {
			const selected = this.selected[0]
			this.$confirm({
				title: '提示',
				content: '确认停用吗 ?',
				onOk: () => {
					const form = {
						id: selected.id,
						ruleStatus: 0,
					}
					return SystemApi.enable(form).then((res: any) => {
						this.$message.success('停用成功')
						this.getList()
					})
				},
			})
		}
	}

	private checkSelected() {
		if (!this.selected.length) {
			this.$message.error('请选择调度规则')
			return false
		}
		return true
	}
}
